import React from 'react';
import { useLanguage } from '../i18n';

/**
 * Practical questions about deployment, availability and collaboration.
 * The English items are mirrored
 * as a schema.org FAQPage in index.html (see src/__tests__/seo.test.ts).
 */
const FAQ: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className="lp-faq" id="faq" aria-labelledby="faq-heading">
      <div className="lp-wrap">
        <div className="lp-section-heading">
          <h2 id="faq-heading">{t.faq.heading}</h2>
        </div>

        <div className="lp-faq-list">
          {t.faq.items.map((item) => (
            <details key={item.id} className="lp-faq-item" id={`faq-${item.id}`}>
              <summary>
                <h3>{item.question}</h3>
              </summary>
              <div>
                <p>{item.answer}</p>
              </div>
            </details>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FAQ;
